var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomers = function SvgCustomers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "customers_svg2__a",
    x1: 32.22,
    x2: 175.71,
    y1: 148.25,
    y2: 74.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M173.7 106.71c10.58-7.19 13.32-21.59 6.14-32.17-7.19-10.58-21.59-13.32-32.17-6.14-10.58 7.19-13.32 21.59-6.14 32.17 1.64 2.41 3.72 4.5 6.14 6.14a39.1 39.1 0 0 0-11.63 6.47 54.9 54.9 0 0 0-20.59-11.3c15.36-8.53 20.9-27.9 12.37-43.26s-27.9-20.9-43.26-12.37-20.9 27.9-12.37 43.26c2.89 5.2 7.17 9.48 12.37 12.37a54.9 54.9 0 0 0-20.59 11.3 39.2 39.2 0 0 0-11.62-6.47c10.59-7.19 13.34-21.6 6.16-32.19-7.19-10.59-21.6-13.34-32.19-6.16-10.59 7.19-13.34 21.6-6.16 32.19a23.1 23.1 0 0 0 6.16 6.16C10.59 112.25.05 127.09 0 143.76c0 1.73 1.4 3.13 3.13 3.13s3.13-1.4 3.13-3.13c.04-18.27 14.87-33.05 33.14-33.01 7.25.01 14.3 2.41 20.06 6.83a54.7 54.7 0 0 0-14.41 37.05c0 1.73 1.4 3.13 3.13 3.13s3.13-1.4 3.13-3.13c.48-26.89 22.67-48.3 49.57-47.82 26.21.47 47.35 21.61 47.82 47.82 0 1.73 1.4 3.13 3.13 3.13s3.13-1.4 3.13-3.13a54.72 54.72 0 0 0-14.41-37.05c14.49-11.12 35.26-8.39 46.38 6.1a33.08 33.08 0 0 1 6.84 20.09c0 1.73 1.4 3.13 3.13 3.13s3.13-1.4 3.13-3.13c-.04-16.67-10.58-31.51-26.3-37.05ZM22.41 87.51c.03-9.35 7.62-16.9 16.97-16.87s16.9 7.62 16.87 16.97c-.03 9.33-7.59 16.87-16.92 16.87-9.35 0-16.93-7.6-16.92-16.95zm52.03-13.47c.03-14.12 11.51-25.53 25.62-25.5 14.12.03 25.53 11.51 25.5 25.62-.03 14.09-11.47 25.5-25.56 25.5-14.11-.02-25.55-11.45-25.56-25.56zm69.31 13.47c0-9.35 7.58-16.92 16.92-16.92s16.92 7.58 16.92 16.92c0 9.35-7.58 16.92-16.92 16.92s-16.91-7.58-16.92-16.92",
    style: {
      fill: "url(#customers_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgCustomers;